"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Task = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const index_1 = require("../index");
class Task extends Base_1.Base {
    name = '';
    changeId = '';
    type = '';
    description = '';
    index = 0;
    completed = 0;
    tested = 0;
    validated = false;
    creator = null;
    validator = null;
    files = [];
    agents = [];
    followers = [];
    roles = [];
    follower_ids = [];
    agent_ids = [];
    metadata = {};
    public = false;
    status = 'backlog';
    labels = [];
    order = 0;
    constructor(data, olMap) {
        super('tasks', 16);
        (0, Common_1.setObjectProperties)(this, data, olMap, Task);
    }
    syncIds() {
        this.agent_ids = [...new Set(this.agents?.map(a => a.id) || [])];
        const followerIds = this.followers?.map(f => f.id) || [];
        this.follower_ids = [...new Set([...followerIds, ...this.agent_ids])];
    }
    toJSON() {
        let r = super.toJSON();
        r.follower_ids = [];
        ['agents', 'creator', 'validator', 'followers', 'files'].forEach(p => {
            r[p] = (0, index_1.toMinJSON)(this, p);
        });
        r.agent_ids = this.agent_ids || [];
        r.follower_ids = this.follower_ids || [];
        r.validated = this.validated || false;
        r.index = this.index || 0;
        r.last_date = this.last_date || r.date;
        r.tested = this.tested || 0;
        r.completed = this.completed || 0;
        r.changeId = this.changeId || '';
        r.status = this.status || 'backlog';
        r.labels = this.labels || [];
        r.order = this.order || 0;
        return r;
    }
    toMinJSON(ignoreDocRef) {
        let r = super.toMinJSON(ignoreDocRef);
        Object.assign(r, {
            name: this.name || '',
            completed: this.completed || 0,
            status: this.status || 'backlog'
        });
        return r;
    }
    async save(parent) {
        this.syncIds();
        return super.save(parent);
    }
    async update(changes) {
        if (changes?.agents) {
            this.agents = changes.agents;
        }
        if (changes?.followers) {
            this.followers = changes.followers;
        }
        if (changes?.agents || changes?.followers) {
            this.syncIds();
            changes.agent_ids = this.agent_ids;
            changes.follower_ids = this.follower_ids;
        }
        return super.update(changes);
    }
}
exports.Task = Task;
index_1.olm.tasks = (ref, map) => {
    return new Task(ref, map);
};
